import { render, staticRenderFns } from "./GeneralSpinner.vue?vue&type=template&id=9cc198c4&scoped=true&"
import script from "./GeneralSpinner.vue?vue&type=script&lang=js&"
export * from "./GeneralSpinner.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSpinner.vue?vue&type=style&index=0&id=9cc198c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc198c4",
  null
  
)

export default component.exports